'use client';

import {
  type AppSidebarData,
  SidebarGroup,
  SidebarGroupContent,
  SidebarMenu,
  SidebarMenuButton,
  SidebarMenuItem,
} from '@repo/ui';
import { Link } from '@/components/link';

export function SidebarNavSecondary({
  items,
  pathname,
}: {
  items: NonNullable<AppSidebarData['navSecondary']>;
  pathname: string | null;
}): React.ReactNode {
  if (!items.length) {
    return null;
  }

  return (
    <SidebarGroup className="mt-auto">
      <SidebarGroupContent>
        <SidebarMenu>
          {items.map((item) => (
            <SidebarMenuItem key={item.title}>
              <SidebarMenuButton asChild isActive={pathname?.startsWith(item.url)}>
                <Link href={item.url}>
                  <item.icon />
                  <span>{item.title}</span>
                </Link>
              </SidebarMenuButton>
            </SidebarMenuItem>
          ))}
        </SidebarMenu>
      </SidebarGroupContent>
    </SidebarGroup>
  );
}
